import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFoundScreen = () => (
    <div className="not-found-page">
        <Helmet>
            <title>Page not found | RetroDayz</title>
            <meta name="robots" content="noindex" />
        </Helmet>
        <h1>Game over! Page not found</h1>
        <p>The page you’re looking for has moved or no longer exists.</p>
        <div className="not-found-actions">
            <Link className="btn btn-primary blue-outline" to="/search/">Browse All Products</Link>
            <Link className="btn btn-light orange-outline" to="/">Back to Home</Link>
        </div>
    </div>
);

export default NotFoundScreen;
